import { NameSpace } from '../root-reducer'

const getSelectedCity = (state) => state[NameSpace.APP].selectedCity
const getEventsList = (state) => state[NameSpace.APP].events
const getFormatList = (state) => state[NameSpace.APP].formats

export { getSelectedCity, getEventsList, getFormatList }
